var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckboxUncheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "anniu_xuanzhong") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.200000003
  }, /*#__PURE__*/React.createElement("g", {
    id: "Market-\\u94FE\\u63A5\\u94B1\\u5305",
    transform: "translate(-634.000000, -219.000000)",
    fill: "#141416"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M642,219.2 C644.145023,219.2 646.094902,220.077709 647.508609,221.491411 C648.922318,222.905114 649.800029,224.854988 649.800029,227 C649.800029,229.145022 648.922321,231.094893 647.508616,232.508593 C646.094908,233.922296 644.145027,234.8 642,234.8 C639.854986,234.8 637.905111,233.922294 636.491406,232.50859 C635.077707,231.094891 634.2,229.145021 634.2,227 C634.2,224.85499 635.07771,222.905117 636.491414,221.491414 C637.905117,220.07771 639.85499,219.2 642,219.2 Z M642,220.799956 C640.294994,220.799956 638.744862,221.497244 637.621065,222.621046 C636.49727,223.744846 635.799985,225.294983 635.799985,227 C635.799985,228.705017 636.49727,230.255154 637.621065,231.378954 C638.744862,232.502756 640.294994,233.200044 642,233.200044 C643.705019,233.200044 645.255157,232.502758 646.378957,231.378957 C647.502758,230.255157 648.200044,228.705019 648.200044,227 C648.200044,225.294981 647.502758,223.744843 646.378957,222.621043 C645.255157,221.497242 643.705019,220.799956 642,220.799956 Z M644.900074,224.082827 L646.017189,225.199965 L641.399999,229.817155 L638.38281,226.799966 L639.500024,225.682846 L641.399995,227.582905 L644.900074,224.082827 Z",
    id: "anniu_xuanzhong"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxUncheck);
export default __webpack_public_path__ + "static/media/checkbox-uncheck.06aaeaba9756cbffeb04763432f05eb8.svg";
export { ForwardRef as ReactComponent };